import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomeComponent from './Login/login.js';
import AdminComponent from './administrador/AdminUsersPage.js';
import AlumnosComponent from './home_alumnos/alumnos.js';

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomeComponent />} />
      <Route path="/admin" element={<AdminComponent />} />
      <Route path="/alumnos" element={<AlumnosComponent />} />
    </Routes>
  );
}

export default AppRoutes;